import { CourseLockScreen } from "@/react/components/Spaces/CourseSpace/CourseLockScreen";
import { CourseSpaceRoutes } from "@circle-react/components/Spaces/CourseSpace/Routes";
import { useIsLockedSpace } from "@circle-react/hooks/useIsLockedSpace";

export const CourseContent = () => {
  const isLockedSpace = useIsLockedSpace();

  if (isLockedSpace) {
    return <CourseLockScreen />;
  }

  return <CourseSpaceRoutes />;
};
